// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aifZeugMlSxE9Vk9k6rg{cursor:pointer}.GSMhzCXqcxgz01cQ3Mn9{padding-bottom:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previousStepLink": "aifZeugMlSxE9Vk9k6rg",
	"fieldset": "GSMhzCXqcxgz01cQ3Mn9"
};
export default ___CSS_LOADER_EXPORT___;
